module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "membership-packages-page"
  }, [_c('div', {
    staticClass: "foo membership-packages-page__header"
  }, [_c('H1', {
    staticClass: "header-h1"
  }, [_vm._v(_vm._s(_vm.locale.t('label_mp_title')))]), _vm._v(" "), _c('div', {
    staticClass: "membership-packages-page__controls"
  }, [_c('div', {
    staticClass: "new-button membership-packages-page__add-btn",
    on: {
      "click": function($event) {
        return _vm.addMembershipPackage()
      }
    }
  }, [_c('i', {
    staticClass: "ti-plus"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_mp_add')))]), _vm._v(" "), _c('span', {
    staticClass: "membership-packages-page__search-wrap"
  }, [_c('i', {
    staticClass: "ti-search membership-packages-page__search-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input membership-packages-page__search-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "users"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "membership-packages-page__content"
  }, _vm._l((_vm.groupedPackages), function(items, category) {
    return _c('div', {
      key: category,
      staticClass: "membership-packages-page__group"
    }, [_c('div', {
      staticClass: "category-header membership-packages-page__category-header",
      on: {
        "click": function($event) {
          return _vm.onHideGroup(category)
        }
      }
    }, [_c('span', [_c('i', {
      class: !_vm.hiddenGroups.includes(category) ? 'ti-arrow-circle-down' : 'ti-arrow-circle-up'
    }), _vm._v(" " + _vm._s(category))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    })]), _vm._v(" "), (!_vm.hiddenGroups.includes(category)) ? _c('div', {
      staticClass: "package-grid"
    }, _vm._l((items), function(item) {
      return _c('div', {
        staticClass: "package-item membership-packages-page__package-item"
      }, [_c('p', {
        staticClass: "membership-packages-page__package-title"
      }, [_vm._v(_vm._s(item.name) + " - " + _vm._s(item.price) + " " + _vm._s(_vm.locale.t('label_currency')))]), _vm._v(" "), _c('p', {
        staticClass: "package-subitem-medium"
      }, [_vm._v(_vm._s(_vm.locale.t('label_mp_during_in_days')) + ": "), _c('b', [_vm._v(_vm._s(item.durationInDays))])]), _vm._v(" "), _c('p', {
        staticClass: "package-subitem-medium"
      }, [_vm._v(_vm._s(_vm.locale.t('label_number_of_trainings')) + ": "), _c('b', [_vm._v(_vm._s(item.trainingNumber))])]), _vm._v(" "), _c('p', {
        staticClass: "package-subitem-small"
      }, [_vm._v(_vm._s(_vm.locale.t('label_payment_type_trainings')) + ": "), _c('b', [_vm._v(_vm._s(item.trainingTypes))])]), _vm._v(" "), (item.additionalKit != null && item.additionalKit.length > 0) ? _c('p', {
        staticClass: "package-subitem-small"
      }, [_vm._v(_vm._s(_vm.locale.t('label_equipment')) + ": "), _c('b', [_vm._v(_vm._s(item.additionalKit))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "flex-container section-top-sm membership-packages-page__actions"
      }, [_c('div', {
        staticClass: "new-button term-subitem-small",
        on: {
          "click": function($event) {
            return _vm.editMembership(item.id)
          }
        }
      }, [_c('i', {
        staticClass: "ti-pencil"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_edit')) + "\n                  ")]), _vm._v(" "), _c('div', {
        staticClass: "new-button term-subitem-small",
        on: {
          "click": function($event) {
            return _vm.deleteMembership(item.id)
          }
        }
      }, [_c('i', {
        staticClass: "ti-trash"
      }), _vm._v(" " + _vm._s(_vm.locale.t('label_delete')) + "\n                  ")])])])
    }), 0) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7484755e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Membership/MembershipPackages.vue
// module id = 790
// module chunks = 0